import * as React from 'react';
import { CircularProgress, CircularProgressProps } from '@mui/material';
import Typography from '@mui/material/Typography';
import Box, { BoxProps } from '@mui/material/Box';

function CircularProgressWithLabel(
  props: CircularProgressProps & {
    value: number;
    progressColor: string;
    size?: number;
  }
) {
  const [animatedValue, setAnimatedValue] = React.useState(0);

  React.useEffect(() => {
    const interval = setInterval(() => {
      setAnimatedValue((prevValue) => {
        const newValue = prevValue + 1;
        return newValue > props.value ? props.value : newValue;
      });
    }, 10);

    return () => clearInterval(interval);
  }, [props.value]);

  const finalSize = props.size ?? 50;

  return (
    <Box
      sx={{ position: 'relative', display: 'inline-flex', cursor: 'pointer' }}
    >
      <CircularProgress
        variant='determinate'
        value={100}
        thickness={6}
        size={finalSize}
        sx={{ color: '#D9D9D9', position: 'absolute' }}
      />
      <CircularProgress
        variant='determinate'
        {...props}
        value={animatedValue}
        thickness={6}
        size={finalSize}
        sx={{ color: props.progressColor }}
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant='caption'
          component='div'
          fontFamily={'Mont-semibold'}
          color={props.progressColor}
        >
          {`${Math.round(props.value)}%`}
        </Typography>
      </Box>
    </Box>
  );
}

export default function SparkCircularProgress({
  value,
  color,
  size = 50,
  containerStyle,
}: {
  value: number;
  color: string;
  size?: number;
  containerStyle?: BoxProps['sx'];
}) {
  return (
    <Box sx={containerStyle}>
      <CircularProgressWithLabel
        value={value}
        progressColor={color}
        size={size}
      />
    </Box>
  );
}
